/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { style } from './index.styles';

const I = styled.i(style, props => {
  delete props.className;

  return props;
});

/**
 * Documentation at:
 * https://github.hugeinc.com/HugeTechnology/IWG/wiki/Font-Icons
 * @deprecated should use icomoon instead.
 * @param {!Object} props Object with the icon name.
 * @param {Object} css Object with custom styles.
 * @returns {Component}
 */
export const Icon = props => {
  const { name, customCss = {}, className } = props;

  return (
    <I css={[style, customCss]} className={`icon icon-${name} ${className}`} />
  );
};

Icon.displayName = 'Icon';
